import React from 'react';
import { RouteConfig } from './routeConfig';

const TheraphyDashboard = React.lazy(
  () =>
    import('../../../containers/TheraphyDashboard/TheraphyDashboardContainer'),
);
const Login = React.lazy(
  () => import('../../../containers/LoginV2/LoginContainerV2'),
);
const LoginV2 = React.lazy(
  () => import('../../../containers/LoginV2/LoginContainerV2'),
);
const NotFound = React.lazy(
  () => import('../features/not-found/NotFoundScreen'),
);
const ClientDashboard = React.lazy(
  () => import('../../../containers/ClientDashboard/ClientDashboardContainer'),
);
const TherapistDashboard = React.lazy(
  () =>
    import(
      '../../../containers/TherapistDashboard/TherapistDashboardContainer'
    ),
);
const SignUp = React.lazy(
  () => import('../../../containers/SignUp/SignUpContainer'),
);
const MFAHelp = React.lazy(
  () => import('../../../containers/SignUp/MFAHelpScreen'),
);
const MFAQR = React.lazy(
  () => import('../../../containers/SignUp/MFAQRScreen'),
);
const TherapistProfileSettings = React.lazy(
  () =>
    import(
      '../../../containers/TherapistProfileSettings/TherapistProfileSettingsContainer'
    ),
);
const SchedulerDashboard = React.lazy(
  () => import('../features/scheduler-dashboard/SchedulerDashboard'),
);
const Settings = React.lazy(
  () => import('../../../containers/Settings/SettingsContainer'),
);
const ForgotPassword = React.lazy(
  () => import('../../../containers/ForgotPassword/ForgotPasswordContainer'),
);
const ChangePassword = React.lazy(
  () => import('../../../containers/ChangePassword/ChangePasswordContainer'),
);
const Main = React.lazy(
  () => import('../features/main-container/MainContainer'),
);

const ResetPassword = React.lazy(
  () => import('../../../containers/ResetPassword/ResetPasswordContainer'),
);
const RequestRematch = React.lazy(
  () =>
    import(
      '../../../containers/ClientRequestRematch/ClientRequestRematchContainer'
    ),
);
const ActivityLog = React.lazy(
  () => import('../../../containers/ActivityLog/ActivityLogContainer'),
);
const LoggingError = React.lazy(
  () => import('../features/logging-error/LoggingErrorScreen'),
);
const Set2FA = React.lazy(
  () => import('../../../components/modules/TwoFactorQR/TwoFactorQRContainer'),
);
const VerifyOnboarding = React.lazy(
  () => import('../features/verify-onboarding/VerifyOnboarding'),
);
const SelfScheduling = React.lazy(
  () => import('../features/self-scheduling/SelfSchedulingContainer'),
);
const BookingIntake = React.lazy(
  () =>
    import('../../../components/modules/BookingIntake/BookingIntakeContainer'),
);
const PracticeProfile = React.lazy(
  () => import('../containers/TherapistProfile/Tabs/PracticeProfile'),
);
const TherapistUserSignUp = React.lazy(
  () => import('../features/therapist-user-signup/TherapistUserSignUp'),
);
const AppointmentConfirmation = React.lazy(
  () => import('../features/appointment-confirmation/AppointmentConfirmation'),
);
const MagicLink = React.lazy(
  () => import('../features/magic-link/MagicLinkLandingPage'),
);
const PaymentAuthorization = React.lazy(
  () => import('../features/payment-authorization/PaymentAuthorization'),
);
const ResetCredentials = React.lazy(
  () => import('../features/ResetCredentials/ResetCredentials'),
);
// ROUTE IMPORT CODE GENERATOR INDICATOR DO NOT DELETE

export const routes = [
  {
    path: '/',
    exact: true,
    name: 'Main',
    component: Main,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/v2/login',
    name: 'LoginV2',
    component: LoginV2,
  },
  {
    path: '/client',
    name: ClientDashboard,
    component: ClientDashboard,
    exact: true,
  },
  {
    path: '/therapist',
    name: TherapistDashboard,
    component: TherapistDashboard,
    // isExact: true
  },
  {
    path: '/settings',
    component: TherapistProfileSettings,
    exact: true,
  },
  {
    path: '/settings/user',
    component: Settings,
    exact: true,
  },
  {
    path: '/scheduler',
    name: SchedulerDashboard,
    component: SchedulerDashboard,
    exact: true,
  },
  {
    path: '/verification/:verificationCode',
    name: AppointmentConfirmation,
    component: AppointmentConfirmation,
    exact: true,
  },
  {
    path: '/intake',
    name: MagicLink,
    component: MagicLink,
    exact: true,
  },
  {
    path: '/_payment-consents/authorize/:CONSENT_VERIFICATION_TOKEN',
    name: PaymentAuthorization,
    component: PaymentAuthorization,
    exact: true,
  },
  {
    path: '/sign-up/:verificationCode',
    name: SignUp,
    component: SignUp,
    exact: true,
  },
  // {
  //     path: '/sign-up/:userRole',
  //     name: SignUp,
  //     component: SignUp,
  //     exact: true
  // },
  {
    path: '/mfa-help',
    name: MFAHelp,
    component: MFAHelp,
    exact: true,
  },
  {
    path: '/practice-profile',
    name: 'practiceprofile',
    component: PracticeProfile,
  },
  {
    path: '/mfa-qr',
    name: MFAQR,
    component: MFAQR,
    exact: true,
  },
  {
    path: '/forgot-password',
    name: ForgotPassword,
    component: ForgotPassword,
  },
  {
    path: '/reset-password',
    name: ForgotPassword,
    component: ForgotPassword,
    exact: true,
  },
  {
    path: '/change-password',
    name: ChangePassword,
    component: ChangePassword,
    exact: true,
  },
  {
    path: '/reset-password/:verificationCode',
    name: ResetPassword,
    component: ResetPassword,
    exact: true,
  },
  {
    path: '/therapy/*',
    component: TheraphyDashboard,
    name: TheraphyDashboard,
  },
  {
    path: '/request-rematch',
    name: RequestRematch,
    component: RequestRematch,
  },
  {
    path: '/activity-log',
    name: 'ActivityLog',
    component: ActivityLog,
  },
  {
    path: '/error',
    name: 'LoggingError',
    component: LoggingError,
  },
  {
    path: '/set2FA',
    name: 'set2FA',
    component: Set2FA,
  }, // ROUTE ENTRY CODE GENERATOR INDICATOR DO NOT DELETE// ROUTE ENTRY CODE GENERATOR INDICATOR DO NOT DELETE
  {
    path: '/verify-onboarding',
    name: 'VerifyOnboarding',
    component: VerifyOnboarding,
  },
  {
    path: '/providers',
    name: 'SelfScheduling',
    component: SelfScheduling,
  },
  {
    path: '/meeting-info',
    name: 'BookingIntake',
    component: BookingIntake,
  },
  {
    path: '/reset-credentials',
    name: 'ResetCredentials',
    component: ResetCredentials,
  },
  {
    path: '/therapist-user-signup',
    name: 'TherapistUserSignUp',
    component: TherapistUserSignUp,
  },
  RouteConfig?.teletherapy,
  RouteConfig?.profilePage,
  RouteConfig?.practiceAdmin,
  RouteConfig?.superAdmin,
  RouteConfig?.resources,
  RouteConfig?.billingAdmin,
  RouteConfig?.payments,
  {
    path: '*',
    name: NotFound,
    component: NotFound,
  },
];
